import React, { useState, useEffect } from "react";
import css from "./board.module.scss";
import { useInView, animated } from "@react-spring/web";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { getCode, addMsg, getMsgList } from "api";

function Index() {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [address, setAddress] = useState("");
  const [industry, setIndustry] = useState("");
  const [content, setContent] = useState("");
  const [code, setCode] = useState("");
  const [codeUrl, setCodeUrl] = useState("");
  const [messageList, setMessageList] = useState([]);
  const [firtstRef, firstRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [secondRef, secondRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
      config: { duration: 300 },
    }),
    { threshold: 0.3, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  useEffect(() => {
    getVerifyCode();
    getMessage();
  }, []);

  const handleSubmit = async () => {
    // 执行你的表单提交逻辑，例如通过 fetch 发送数据到服务器
    if (!validate()) {
      return;
    }
    const req = {
      name,
      phone,
      company,
      address,
      industry,
      content,
      verifyCode: code,
    };
    const res = await addMsg(req);
    if (res.code === 200) {
      toast.success("已经收到了您的宝贵意见，我们会尽快联系您", {
        position: "top-center",
      });
      clearForm();
      getVerifyCode();
    } else {
      toast.error(res.message, {
        position: "top-center",
      });
    }
  };
  const clearForm = () => {
    setName("");
    setPhone("");
    setCompany("");
    setAddress("");
    setIndustry("");
    setContent("");
    setCode("");
  };

  const getVerifyCode = async () => {
    const res = await getCode();
    const blob = new Blob([res], { type: "image/png" });
    const url = URL.createObjectURL(blob);
    setCodeUrl(url);
  };

  const validate = () => {
    if (!name || !name.length) {
      toast.warn("请输入姓名", { position: "top-center" });
      return false;
    }
    if (!phone || !phone.length) {
      toast.warn("请输入联系方式", { position: "top-center" });
      return false;
    }
    if (!company || !company.length) {
      toast.warn("请输入公司名称", { position: "top-center" });
      return false;
    }
    if (!address || !address.length) {
      toast.warn("请输入省市", { position: "top-center" });
      return false;
    }
    if (!industry || !industry.length) {
      toast.warn("请输入行业", { position: "top-center" });
      return false;
    }
    return true;
  };

  const getMessage = async () => {
    const res = await getMsgList();
    console.log(res);
    if (res.code === 200) {
      setMessageList(res.data);
    }
  };

  return (
    <div className={css.contain}>
      <div className={css.maintitle}>{t("留言板")}</div>
      <div className={css.first} ref={firtstRef}>
        <animated.div className={css.inner} style={firstRefStyle}>
          <div className={css.left}>
            <div className={css.title}>{t("$singlee_ba1")}</div>
            <div className={css.form}>
              <div className={css.grid}>
                <div className={css.formItem}>
                  <input
                    type="text"
                    placeholder={t("$singlee_ba2")}
                    name="name"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                  />
                </div>
                <div className={css.formItem}>
                  <input
                    type="text"
                    placeholder={t("$singlee_ba3")}
                    name="phone"
                    value={phone}
                    onChange={(event) => setPhone(event.target.value)}
                  />
                </div>
                <div className={css.formItem}>
                  <input
                    type="text"
                    placeholder={t("$singlee_ba4")}
                    name="company"
                    value={company}
                    onChange={(event) => setCompany(event.target.value)}
                  />
                </div>
                <div className={css.formItem}>
                  <input
                    type="text"
                    placeholder={t("$singlee_ba5")}
                    name="address"
                    value={address}
                    onChange={(event) => setAddress(event.target.value)}
                  />
                </div>
                <div className={css.formItem}>
                  <input
                    type="text"
                    placeholder={t("$singlee_ba6")}
                    name="industry"
                    value={industry}
                    onChange={(event) => setIndustry(event.target.value)}
                  />
                </div>
              </div>
              <div className={css.formItem2}>
                <textarea
                  placeholder={t("$singlee_ba7")}
                  name="content"
                  value={content}
                  onChange={(event) => setContent(event.target.value)}
                />
              </div>
              <div className={css.grid}>
                <div className={`${css.formItem} ${css.code}`}>
                  <input
                    type="text"
                    placeholder={t("$singlee_ba8")}
                    name="code"
                    value={code}
                    onChange={(event) => setCode(event.target.value)}
                  />
                  <div className={css.pic} onClick={getVerifyCode}>
                    <img
                      style={{ width: "100%", height: "100%" }}
                      src={codeUrl}
                      alt=""
                    />
                  </div>
                </div>
                <div className={css.formItem}>
                  <button onClick={handleSubmit}>{t("提交")}</button>
                </div>
              </div>
            </div>
          </div>
          <div className={css.right}></div>
        </animated.div>
      </div>
      <div className={css.second} ref={secondRef}>
        <animated.div className={css.inner} style={secondRefStyle}>
          {messageList.map((item, index) => {
            return (
              <div className={css.item} key={index}>
                <div className={css.q}>Q:{item.content}</div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: "A:" + item.title,
                  }}
                ></div>
              </div>
            );
          })}
        </animated.div>
      </div>
    </div>
  );
}

export default React.memo(Index);
